import { NgModule } from '@angular/core';
import { DelphiColorPipe } from './delphi-color.pipe';

@NgModule({
  declarations: [DelphiColorPipe],
  exports: [DelphiColorPipe]
})
export class DelphiColorPipeModule {}
